import { useMemo } from 'react';
import { formatUrl } from '../helpers/utils';

/**
 * Custom hook to generate breadcrumbs for different page types
 * Handles category and city page breadcrumb generation
 */
export const useBreadcrumbs = (pageType, pageData, routerQuery) => {
    return useMemo(() => {
        if (pageType === 'city') {
            return [
                { name: 'Home', url: '/' },
                { 
                    name: pageData?.categoryTitle || routerQuery.categorySlug?.replace(/-/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || 'Category', 
                    url: routerQuery.categorySlug ? formatUrl(routerQuery.categorySlug) : '/' 
                },
                { 
                    name: pageData?.cityTitle || routerQuery.citySlug?.replace(/-/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || 'City', 
                    url: null // Current page, no URL for Link
                }
            ];
        }

        if (pageType === 'category') {
            return [
                { name: 'Home', url: '/' },
                { name: pageData?.name || routerQuery.categorySlug || 'Category', url: null }
            ];
        }

        if (pageType === 'sub') {
            return [
                { name: 'Home', url: '/' },
                { 
                    name: pageData?.categoryTitle || routerQuery.categorySlug?.replace(/-/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || 'Category', 
                    url: routerQuery.categorySlug ? formatUrl(routerQuery.categorySlug) : '/' 
                },
                { 
                    name: pageData?.cityTitle || routerQuery.citySlug?.replace(/-/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || 'City', 
                    url: routerQuery.categorySlug && routerQuery.citySlug ? formatUrl(routerQuery.categorySlug, routerQuery.citySlug) : null
                },
                { 
                    name: pageData?.subTitle || routerQuery.subSlug?.replace(/-/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || 'Sub Page', 
                    url: null // Current page, no URL for Link
                }
            ];
        }

        return [];
    }, [pageType, pageData, routerQuery]);
};

export default useBreadcrumbs;